import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  StateService,
  UserType,
  Company,
  ToolService,
  HelpComponent,
  CompanyFormComponent,
} from '../../public-api';
import { Subscription } from 'rxjs';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'lib-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  standalone: false,
})
export class SettingsComponent implements OnInit, OnDestroy {
  constructor(
    public state: StateService,
    public tools: ToolService,
    private modalController: ModalController
  ) {}

  private subs: Subscription[] = [];
  nodeItemsStorageInGb: string;
  selectedCompany: Company;
  ngOnInit() {
    this.state.loadSignature();
    this.nodeItemsStorageInGb = this.state.calculateStorageSize();
    this.subs.push(this.state.selectedCompany$.subscribe(x => this.selectedCompany = x));
  }

  ngOnDestroy() {
    this.subs?.forEach((x) => x.unsubscribe());
  }

  saveSignature(text: string) {
    this.state.saveSignature(text);
  }

  getUserType(): string {
    if (this.state.userType == UserType.$1) return 'Büronutzer';
    if (this.state.userType == UserType.$2) return 'Firmenadmin';
    if (this.state.userType == UserType.$3) return 'App-Admin';
    return 'Standartnutzer';
  }

  itemChanged(company: Company) {
    this.state.changeSelectedCompany(company);
  }

  async showHelpModal() {
    const modal = await this.modalController.create({
      component: HelpComponent,
    });
    modal.present();
  }

  async createCompany(){
 const modal = await this.modalController.create({
      component: CompanyFormComponent,
    });
    modal.present();
  }

  async editCompany(){
const modal = await this.modalController.create({
      component: CompanyFormComponent,
      componentProps: {
        companyId: this.selectedCompany.id
      }
    });
    modal.present();
  }
}
